import { Component } from '@angular/core';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import * as XLSX from 'xlsx';
import { NavigationExtras } from '@angular/router';
import { DatePipe } from '@angular/common';
import { VendorSearchDTO,AddressSearchDTO,GstinSearchDTO } from '../../../../models/vendor-SearchDTO';
interface FilterDate{
  startDate:any
  endDate:any
  vendorNames:string
  purchase_organization:string
}
interface CityAndState {
  city: string;
  state: string;
  name: string;
  state_code: string;
}
interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-approve-vendor-list',
  templateUrl: './approve-vendor-list.component.html',
  styleUrl: './approve-vendor-list.component.scss'
})
export class ApproveVendorListComponent {
  vendorList: any[] = [];
  cols!: Column[];
  selectedVendorList: string[] = [];

  selectedVendor:any [] =[];

  vendorStatus="APPROVED"
  isCardView=true
  isListView=false
  limit:number=10;
  currentPage:number=1;
  totalRecords:number=0
  isLoading: boolean = false;
  vendorSearchDTO?:VendorSearchDTO
  addressSearchDTO?:AddressSearchDTO
  gstinSearchDTO?:GstinSearchDTO
  public searchTerm: string = '';
  startDate: Date | null = null;
  endDate: Date | null = null;
  dateValidation1: boolean = false;

  countries_List = [
    { label: 'Afghanistan', value: 'AF' },
    { label: 'Albania', value: 'AL' },
    { label: 'Algeria', value: 'DZ' },
    { label: 'Andorra', value: 'AD' },
    { label: 'Angola', value: 'AO' },
    { label: 'Antigua and Barbuda', value: 'AG' },
    { label: 'Argentina', value: 'AR' },
    { label: 'Armenia', value: 'AM' },
    { label: 'Australia', value: 'AU' },
    { label: 'Austria', value: 'AT' },
    { label: 'Azerbaijan', value: 'AZ' },
    { label: 'Bahamas', value: 'BS' },
    { label: 'Bahrain', value: 'BH' },
    { label: 'Bangladesh', value: 'BD' },
    { label: 'Barbados', value: 'BB' },
    { label: 'Belarus', value: 'BY' },
    { label: 'Belgium', value: 'BE' },
    { label: 'Belize', value: 'BZ' },
    { label: 'Benin', value: 'BJ' },
    { label: 'Bhutan', value: 'BT' },
    { label: 'Bolivia', value: 'BO' },
    { label: 'Bosnia and Herzegovina', value: 'BA' },
    { label: 'Botswana', value: 'BW' },
    { label: 'Brazil', value: 'BR' },
    { label: 'Brunei', value: 'BN' },
    { label: 'Bulgaria', value: 'BG' },
    { label: 'Burkina Faso', value: 'BF' },
    { label: 'Burundi', value: 'BI' },
    { label: 'Cabo Verde', value: 'CV' },
    { label: 'Cambodia', value: 'KH' },
    { label: 'Cameroon', value: 'CM' },
    { label: 'Canada', value: 'CA' },
    { label: 'Central African Republic', value: 'CF' },
    { label: 'Chad', value: 'TD' },
    { label: 'Chile', value: 'CL' },
    { label: 'China', value: 'CN' },
    { label: 'Colombia', value: 'CO' },
    { label: 'Comoros', value: 'KM' },
    { label: 'Congo, Democratic Republic of the', value: 'CD' },
    { label: 'Congo, Republic of the', value: 'CG' },
    { label: 'Costa Rica', value: 'CR' },
    { label: 'Croatia', value: 'HR' },
    { label: 'Cuba', value: 'CU' },
    { label: 'Cyprus', value: 'CY' },
    { label: 'Czech Republic', value: 'CZ' },
    { label: 'Denmark', value: 'DK' },
    { label: 'Djibouti', value: 'DJ' },
    { label: 'Dominica', value: 'DM' },
    { label: 'Dominican Republic', value: 'DO' },
    { label: 'Ecuador', value: 'EC' },
    { label: 'Egypt', value: 'EG' },
    { label: 'El Salvador', value: 'SV' },
    { label: 'Equatorial Guinea', value: 'GQ' },
    { label: 'Eritrea', value: 'ER' },
    { label: 'Estonia', value: 'EE' },
    { label: 'Eswatini', value: 'SZ' },
    { label: 'Ethiopia', value: 'ET' },
    { label: 'Fiji', value: 'FJ' },
    { label: 'Finland', value: 'FI' },
    { label: 'France', value: 'FR' },
    { label: 'Gabon', value: 'GA' },
    { label: 'Gambia', value: 'GM' },
    { label: 'Georgia', value: 'GE' },
    { label: 'Germany', value: 'DE' },
    { label: 'Ghana', value: 'GH' },
    { label: 'Greece', value: 'GR' },
    { label: 'Grenada', value: 'GD' },
    { label: 'Guatemala', value: 'GT' },
    { label: 'Guinea', value: 'GN' },
    { label: 'Guinea-Bissau', value: 'GW' },
    { label: 'Guyana', value: 'GY' },
    { label: 'Haiti', value: 'HT' },
    { label: 'Honduras', value: 'HN' },
    { label: 'Hungary', value: 'HU' },
    { label: 'Iceland', value: 'IS' },
    { label: 'India', value: 'IN' },
    { label: 'Indonesia', value: 'ID' },
    { label: 'Iran', value: 'IR' },
    { label: 'Iraq', value: 'IQ' },
    { label: 'Ireland', value: 'IE' },
    { label: 'Israel', value: 'IL' },
    { label: 'Italy', value: 'IT' },
    { label: 'Ivory Coast', value: 'CI' },
    { label: 'Jamaica', value: 'JM' },
    { label: 'Japan', value: 'JP' },
    { label: 'Jordan', value: 'JO' },
    { label: 'Kazakhstan', value: 'KZ' },
    { label: 'Kenya', value: 'KE' },
    { label: 'Kiribati', value: 'KI' },
    { label: 'Kuwait', value: 'KW' },
    { label: 'Kyrgyzstan', value: 'KG' },
    { label: 'Laos', value: 'LA' },
    { label: 'Latvia', value: 'LV' },
    { label: 'Lebanon', value: 'LB' },
    { label: 'Lesotho', value: 'LS' },
    { label: 'Liberia', value: 'LR' },
    { label: 'Libya', value: 'LY' },
    { label: 'Liechtenstein', value: 'LI' },
    { label: 'Lithuania', value: 'LT' },
    { label: 'Luxembourg', value: 'LU' },
    { label: 'Madagascar', value: 'MG' },
    { label: 'Malawi', value: 'MW' },
    { label: 'Malaysia', value: 'MY' },
    { label: 'Maldives', value: 'MV' },
    { label: 'Mali', value: 'ML' },
    { label: 'Malta', value: 'MT' },
    { label: 'Marshall Islands', value: 'MH' },
    { label: 'Mauritania', value: 'MR' },
    { label: 'Mauritius', value: 'MU' },
    { label: 'Mexico', value: 'MX' },
    { label: 'Micronesia', value: 'FM' },
    { label: 'Moldova', value: 'MD' },
    { label: 'Monaco', value: 'MC' },
    { label: 'Mongolia', value: 'MN' },
    { label: 'Montenegro', value: 'ME' },
    { label: 'Morocco', value: 'MA' },
    { label: 'Mozambique', value: 'MZ' },
    { label: 'Myanmar', value: 'MM' },
    { label: 'Namibia', value: 'NA' },
    { label: 'Nauru', value: 'NR' },
    { label: 'Nepal', value: 'NP' },
    { label: 'Netherlands', value: 'NL' },
    { label: 'New Zealand', value: 'NZ' },
    { label: 'Nicaragua', value: 'NI' },
    { label: 'Niger', value: 'NE' },
    { label: 'Nigeria', value: 'NG' },
    { label: 'North Korea', value: 'KP' },
    { label: 'North Macedonia', value: 'MK' },
    { label: 'Norway', value: 'NO' },
    { label: 'Oman', value: 'OM' },
    { label: 'Pakistan', value: 'PK' },
    { label: 'Palau', value: 'PW' },
    { label: 'Panama', value: 'PA' },
    { label: 'Papua New Guinea', value: 'PG' },
    { label: 'Paraguay', value: 'PY' },
    { label: 'Peru', value: 'PE' },
    { label: 'Philippines', value: 'PH' },
    { label: 'Poland', value: 'PL' },
    { label: 'Portugal', value: 'PT' },
    { label: 'Qatar', value: 'QA' },
    { label: 'Romania', value: 'RO' },
    { label: 'Romania', value: 'RO' },
    { label: 'Russia', value: 'RU' },
    { label: 'Rwanda', value: 'RW' },
    { label: 'Saint Kitts and Nevis', value: 'KN' },
    { label: 'Saint Lucia', value: 'LC' },
    { label: 'Saint Vincent and the Grenadines', value: 'VC' },
    { label: 'Samoa', value: 'WS' },
    { label: 'San Marino', value: 'SM' },
    { label: 'Sao Tome and Principe', value: 'ST' },
    { label: 'Saudi Arabia', value: 'SA' },
    { label: 'Senegal', value: 'SN' },
    { label: 'Serbia', value: 'RS' },
    { label: 'Seychelles', value: 'SC' },
    { label: 'Sierra Leone', value: 'SL' },
    { label: 'Singapore', value: 'SG' },
    { label: 'Slovakia', value: 'SK' },
    { label: 'Slovenia', value: 'SI' },
    { label: 'Solomon Islands', value: 'SB' },
    { label: 'Somalia', value: 'SO' },
    { label: 'South Africa', value: 'ZA' },
    { label: 'South Korea', value: 'KR' },
    { label: 'South Sudan', value: 'SS' },
    { label: 'Spain', value: 'ES' },
    { label: 'Sri Lanka', value: 'LK' },
    { label: 'Sudan', value: 'SD' },
    { label: 'Suriname', value: 'SR' },
    { label: 'Sweden', value: 'SE' },
    { label: 'Switzerland', value: 'CH' },
    { label: 'Syria', value: 'SY' },
    { label: 'Taiwan', value: 'TW' },
    { label: 'Tajikistan', value: 'TJ' },
    { label: 'Tanzania', value: 'TZ' },
    { label: 'Thailand', value: 'TH' },
    { label: 'Timor-Leste', value: 'TL' },
    { label: 'Togo', value: 'TG' },
    { label: 'Tonga', value: 'TO' },
    { label: 'Trinidad and Tobago', value: 'TT' },
    { label: 'Tunisia', value: 'TN' },
    { label: 'Turkey', value: 'TR' },
    { label: 'Turkmenistan', value: 'TM' },
    { label: 'Tuvalu', value: 'TV' },
    { label: 'Uganda', value: 'UG' },
    { label: 'Ukraine', value: 'UA' },
    { label: 'United Arab Emirates', value: 'AE' },
    { label: 'United Kingdom', value: 'GB' },
    { label: 'United States', value: 'US' },
    { label: 'Uruguay', value: 'UY' },
    { label: 'Uzbekistan', value: 'UZ' },
    { label: 'Vanuatu', value: 'VU' },
    { label: 'Vatican City', value: 'VA' },
    { label: 'Venezuela', value: 'VE' },
    { label: 'Vietnam', value: 'VN' },
    { label: 'Yemen', value: 'YE' },
    { label: 'Zambia', value: 'ZM' },
    { label: 'Zimbabwe', value: 'ZW' },
  ];

  state = [
    { label: 'Andaman and Nico.In.', value: '26' },
    { label: 'Andra Pradesh', value: '01' },
    { label: 'Arunachal Pradesh', value: '02' },
    { label: 'Assam', value: '03' },
    { label: 'Bihar', value: '04' },
    { label: 'Chandigarh', value: '27' },
    { label: 'Chhaattisgarh', value: '33' },
    { label: 'Dadra und Nagar Hav.', value: '28' },
    { label: 'Daman und Diu', value: '29' },
    { label: 'Delhi', value: '30' },
    { label: 'Exports', value: '96' },
    { label: 'Goa', value: '05' },
    { label: 'Gujarat', value: '06' },
    { label: 'Haryana', value: '07' },
    { label: 'Himachal Pradesh', value: '08' },
    { label: 'Jammu and Kashmir', value: '09' },
    { label: 'Jharkhand', value: '34' },
    { label: 'Karnataka', value: '10' },
    { label: 'Kerala', value: '11' },
    { label: 'Lakshadweep', value: '31' },
    { label: 'Madhya Pradesh', value: '12' },
    { label: 'Maharashtra', value: '13' },
    { label: 'Manipur', value: '14' },
    { label: 'Megalaya', value: '15' },
    { label: 'Mizoram', value: '16' },
    { label: 'Nagaland', value: '17' },
    { label: 'Orissa', value: '18' },
    { label: 'Other - Exports', value: '00' },
    { label: 'Pondicherry', value: '32' },
    { label: 'Punjab', value: '19' },
    { label: 'Rajasthan', value: '20' },
    { label: 'Sikkim', value: '21' },
    { label: 'Tamil Nadu', value: '22' },
    { label: 'Telangana', value: '36' },
    { label: 'Tripura', value: '23' },
    { label: 'Uttar Pradesh', value: '24' },
    { label: 'Uttarakhand', value: '35' },
    { label: 'West Bengal', value: '25' },
  ];


  isExcel: boolean = false;
  correctDate: Date = new Date();
  cityAndStateList: any[] = [];
  vendorNames:string=''
  purchase_organization:string=''
  constructor(private vendorService: VendorTsService,
              private datePipe: DatePipe,
              private router: Router,
              private messageService: MessageService)
               {
                this.vendorSearchDTO= new VendorSearchDTO()
                this.addressSearchDTO= new AddressSearchDTO()
                this.gstinSearchDTO= new GstinSearchDTO()
               }


  ngOnInit(): void {
    this.initializeColumns()
    // this.CityAndState()
    this.getPageableVendorMasterList()
  }
  // CityAndState(){
  //   this.vendorService.getCityAndState().then((res)=>{
  //     this.cityAndStateList = res.message
  //   }).catch((error)=>{
  //     console.log(error)
  //   })
  // }

  getPageableVendorMasterList(){
    let data={
      page:this.currentPage,
      limit:this.limit,
      status:this.vendorStatus,
      gstin_search_dto:this.gstinSearchDTO,
      vendor_search_dto:this.vendorSearchDTO,
      address_search_dto:this.addressSearchDTO
      }
      this.isLoading=true
    this.vendorService.getPageableVendorMasterList(data)
    .then(result => {
      this.isLoading=false
      this.vendorList = result.message.vendor_list;
      this.totalRecords = result.message.total_vendor;
    })
    .catch(error => {
      this.isLoading=false
      console.error('Error in component:', error);
    });
  }

  getcountries(countrie:string): any{
    const countri= this.countries_List.find((data)=> data.value === countrie)
     return countri?.label
   }

   getStateLabel(value: string, country: any): any {
    const stateObj = this.state.find(s => s.value === value);
    if (country === 'IN') {
      return stateObj?.label
    } else {
      return value
    }
  }

  //  getStateLabel(value: string, country: any,city:string): any {
  //   // const stateObj = this.cityAndStateList.find(s => s.state_code === value && s.city === city);
  //   if (country === 'IN' && city && value) {
  //     // Convert city to uppercase for case-insensitive comparison, only if it's a valid string
  //     const cityUpper = city ? city.toUpperCase() : ''; // Handle null/undefined city gracefully

  //     // Build the lookup map with uppercase city comparison, checking if item.city exists
  //     const lookupMap = this.cityAndStateList.reduce((map, item) => {
  //       if (item.city) { // Ensure item.city is not null or undefined
  //         const key = `${item.state_code}_${item.city.toUpperCase()}`;
  //         map[key] = item;
  //       }
  //       return map;
  //     }, {});

  //     const key = `${value}_${cityUpper}`; // Use uppercase city in key
  //     const stateObj = lookupMap[key];
  //     return stateObj?.state;
  //   } else if (country === 'IN' && (city === "" || city == null || city == undefined)) {
  //     const stateObj1 = this.state.find(s => s.value === value);
  //     return stateObj1?.label;
  //   } else {
  //     return value;
  //   }
  // }

  onClickExcel(){
    this.isExcel=true
  }

  onCloseForExcelReport(){
    this.isExcel=false
    this.startDate=null
    this.endDate=null
    this.purchase_organization=""
    this.vendorNames=""
    this.dateValidation1=false
  }

   onDowunloadVendorListByDate(){
    // if (this.startDate != null && this.endDate != null) {

    let date:FilterDate = {
      startDate:this.datePipe.transform(this.startDate, 'yyyy-MM-dd'),
      endDate:this.datePipe.transform(this.endDate, 'yyyy-MM-dd HH:mm:ss'),
      purchase_organization:this.purchase_organization,
      vendorNames:this.vendorNames
    }
    this.isLoading=true
    this.isExcel=false
    this.vendorService.downloadVendorByDate(date).then((res)=>{
      if(res.message === "No Record Found"){
        this.messageService.add({ severity: "info", summary: 'Info', detail: "No Data Found."})
      }else{
        const fileContent = res.filecontent;
        const blob = new Blob([new Uint8Array(fileContent)], {
          type: 'application/octet-stream'
        });

        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        if (date.startDate != null && date.endDate != null) {
          downloadLink.download = `vendor_report${date.startDate}_${date.endDate}.xlsx`;
        }else{
          downloadLink.download = `vendor_report.xlsx`;
        }


        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.messageService.add({ severity: "success", summary: 'Success', detail: "Vendor Report downloaded successfully."})
      }
      this.onCloseForExcelReport();
      this.isLoading=false

    }).catch((error)=>{
      console.log(error)
    })

  // }
  }
  validateDate() {
    if (this.startDate && this.endDate) {
      const difference = this.getDateDifference();
      if (difference > 12 || this.endDate < this.startDate) {
        this.dateValidation1 = true;
      } else {
        this.dateValidation1 = false;
      }
    }
  }

  getDateDifference(): number {
    if (this.startDate && this.endDate) {
      const start = new Date(this.startDate);
      const end = new Date(this.endDate);
      const diffTime = Math.abs(end.getTime() - start.getTime());
      const diffMonths = diffTime / (1000 * 3600 * 24 * 31); // approx. 30 days in a month
      return diffMonths;
    }
    return 0;
  }

  goToVendorDetails(get_user: string,status:string,businessName:string): void {
    const navigationExtras: NavigationExtras = {
      state: {
        get_user: get_user,
        status:status,
      }
    };
    this.router.navigate(['/view-vendor-details',businessName], navigationExtras);

    // this.router.navigate(['/vendor-detail', businessName]);
  }
  goToChangeRequest(vendorId: string): void {
    this.router.navigate(['/portal/vendor/change-request', vendorId]);
  }

  initializeColumns() {
    this.cols = [
      { field: 'business_name' ,header: 'Name'},
      { field: 'vendor_code' ,header: 'Vendor Code'},
      { field: 'address_title' ,header: 'Primary Address'},
      { field: 'city' ,header: 'City'},
      { field: 'state' ,header: 'State'},
      { field: 'country' ,header: 'Country'},
      { field: 'gstn' ,header: 'GSTIN Number'},
      { field: 'pan_no',header: 'Pan Number'},
      { field: 'select_industry_type',header: 'Industry Type'},
      { field: 'payment_term',header: 'Payment Term'},
      { field: 'new_account_group',header: 'Account Group'},
      { field: 'purchase_organization',header: 'Purchase Organization'},
      { field: 'status' ,header: 'Status'},
      { field: 'creation_date' ,header: 'Creation Date'},
      { field: 'is_black_list' ,header: 'Is Black List'},
      { field: 'is_legal_case' ,header: 'Is Legal Case'},
      { field: 'black_list_remark',header: 'Black List Remark'},
    ];
  }

  onInputChange(event: any, field: string) {
    const inputValue = (event.target as HTMLInputElement)?.value;

    if ("business_name" == field || "vendor_code" == field ||"status" == field ||"creation_date" == field
    ||"is_black_list" == field ||"is_legal_case" == field ||"black_list_remark" == field ||"reject_reason" == field
    ||"pan_no" == field||"select_industry_type" == field||"payment_term" == field ||"new_account_group" == field ||"purchase_organization" == field) {
      (this.vendorSearchDTO as any)[field] = inputValue;
    }
    if ("address_title" == field || "city" == field ||"state" == field ||"country" == field) {
      (this.addressSearchDTO as any)[field] = inputValue;
    }
    if ("gstn" == field) {
      (this.gstinSearchDTO as any)[field] = inputValue;
    }

    this.currentPage=1
    this.getPageableVendorMasterList()
    // this.tt?.filter(inputValue, field, 'contains');
  }

  cardView(){
    this.isListView=false;
    this.isCardView=true;
  }

  listView(){
    this.isListView=true;
    this.isCardView=false;
  }
  onPageChange(event:any){
    this.currentPage=event.page + 1
    this.limit=event.rows
    this.getPageableVendorMasterList()
  }
  applySearch() {}

  downloadExcel(): void {
    const formattedData = this.formatDataForExcel(this.vendorList);
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const colWidths = this.calculateColumnWidths(formattedData);

     // Set the column widths
     ws['!cols'] = colWidths.map(width => ({ wch: width }));
     XLSX.utils.book_append_sheet(wb, ws, 'VendorList');
     XLSX.writeFile(wb, 'vendor_list.xlsx');
  }

  calculateColumnWidths(data: any[]): number[] {
    const colWidths: number[] = [];
    const keys = Object.keys(data[0]);

    keys.forEach((key, colIndex) => {
        let maxWidth = key.length;
        data.forEach(row => {
            maxWidth = Math.max(maxWidth, row[key] ? row[key].toString().length : 0);
        });
        colWidths[colIndex] = maxWidth + 2;
    });

    return colWidths;
  }


  formatDataForExcel(data: any[]): any[] {

    const formattedData = data.map(vendor => ({
      'Name': vendor.business_name,
      'Vendor Code': vendor.vendor_code,
      'Pan No':vendor.pan_no,
      'Status':vendor.status,
      'Vendor Classification':vendor.vendor_classification,
      'Turn Over Previous Year':vendor.previous_year,
      'Turn Over One Year Before Previous Year':vendor.one_year_before_previous_year,
      'Turn Over Two Years Before Previous Year':vendor.two_years_before_previous_year,
      'Legal Name':vendor.legal_name,
      'TIN No':vendor.tin_no,
      'DIN No':vendor.din_no,
      'MSME No':vendor.msme_no,
      'Aadhar No':vendor.aadhar_no,
      'Address Title': vendor.address_title,
      'Address Type': vendor.address_type,
      'Address Line': vendor.address_line_1,
      'Fax': vendor.fax,
      'City': vendor.city,
      'State': vendor.state,
      'Country': vendor.country,
      'GSTIN Number': vendor.gstn,
      'Account Holder Registered Name': vendor.account_holder__registered_name,
      'Account Number': vendor.account_no,
      'IFSC Code': vendor.ifsc_code,
      'Bank Name': vendor.bank_name,
      'Bank Address': vendor.bank_address,
      'Contact Person Name': vendor.name1,
      'Phone Number': vendor.phone_no,
      'Mobile Number': vendor.mobile_no,
      'Email ID': vendor.e_mail_id,
      'Website URL': vendor.website_url,
      'Creation Date': vendor.creation_date,
      'Is Black List': vendor.is_black_list,
      'Is Legal Case': vendor.is_legal_case,
      'Black List Remark': vendor.black_list_remark,
    }));
    return formattedData;
  }
}
